import { Component, h, Prop } from '@stencil/core';
import dayjs from 'dayjs';

@Component({
  tag: 'pnk-datepicker-nav',
  styleUrl: 'pnk-datepicker-nav.css',
})
export class PnkDatePickerNav {
  @Prop() disabled: boolean = false;

  @Prop() currentDate: Date = new Date();

  @Prop() format: string | undefined;

  @Prop() navStep: string = 'd';

  @Prop() dateChange!: (date: Date) => void;

  @Prop() toggleView!: () => void;

  @Prop() renderDate!: () => void;

  setClassNav() {
    let classStyle;
    if (this.disabled === false) {
      classStyle = 'pnk-p-2 pnk-cursor-pointer pnk-flex pnk-flex-wrap pnk-bg-disabled-base pnk-w-72 pnk-h-10 pnk-text-base pnk-rounded pnk-justify-between';
    } else {
      classStyle = 'pnk-p-2 pnk-flex pnk-flex-wrap pnk-bg-disabled-text pnk-w-72 pnk-h-10 pnk-text-white pnk-rounded pnk-justify-between';
    }
    return classStyle;
  }

  setNavInner() {
    let classStyle;
    if (this.disabled === true) {
      classStyle = 'pnk-items-center pnk-text-disabled-base pnk-text-center pnk-justify-center pnk-flex ';
    } else {
      classStyle = 'pnk-items-center pnk-text-base pnk-text-black pnk-text-center pnk-justify-center pnk-flex ';
    }
    return classStyle;
  }

  iconClass() {
    let iconClass;
    if (this.disabled === true) {
      iconClass = 'pnk-text-disabled-base';
    } else {
      iconClass = 'hover:pnk-text-primary-base';
    }
    return iconClass;
  }

  // component used to show date selected in the datepicker or default date choosen
  render() {
    return (
      <div class={this.setClassNav()} onClick={() => this.toggleView?.()}>
        <div class={this.setNavInner()}>{this.renderDate ? this.renderDate() : dayjs(this.currentDate).format(this.format)}</div>
        <div class="pnk-items-center pnk-justify-center pnk-flex ">
          <pnk-icon icon="pnk-calendar" class={this.iconClass()}></pnk-icon>
        </div>
      </div>
    );
  }
}
